import { render } from "./addEditTask.vue?vue&type=template&id=0fcb1c80"
import script from "./addEditTask.vue?vue&type=script&lang=js"
export * from "./addEditTask.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__